import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  XrkTable,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  XrkMessage,
  XrkMessageBox,
  useInputColumn,
  useSelectColumn,
  useCreateModal,
  XrkTableProps,
  createDisabledDate,
  BaseSwitch
} from 'xrk-components';

import BiTmplAddDialog from '../components/bi-tmpl-add-dialog.vue';

import { formatter, resource } from '@/utils';
import { list, enable, deleteTel } from '../data-source/apis';
import { SCENE_MAPPING } from '../constants';
import { BiTmplProject } from '../components/bi-tmpl-project';
import usePreview from '../hooks/use-preview';
import { useBiTmplDetailSteup } from '../store';

const START_UP = 1;

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-list',
  setup(__props) {

const router = useRouter();

const xrkTableRef = ref<XrkTableRef>(null);
const getListAjax = async params => {
  const resp = await list({
    ...params,
    createDtStart: params['submitDt']?.[0],
    createDtEnd: params['submitDt']?.[1]
  });
  return resp;
};
const searchConfig: XrkTableProps['searchConfig'] = {
  searchColumns: [
    {
      type: 'datePicker',
      prop: 'submitDt',
      label: '创建时间',
      style: {
        width: '245px'
      },
      config: {
        type: 'daterange',
        startPlaceholder: '创建时间起',
        endPlaceholder: '创建时间止',
        clearable: true,
        disabledDate: createDisabledDate({ year: 1, month: 0, day: 0 })
      }
    },
    useInputColumn({
      prop: 'templateName',
      type: 'input',
      label: '模板名称',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请输入模板名称',
        clearable: true,
        maxlength: 20
      }
    }),
    useSelectColumn({
      prop: 'sceneType',
      label: '关联内容',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请选择关联内容',
        options: Object.values(SCENE_MAPPING).sort((a, b) => a.sort - b.sort),
        clearable: true
      }
    })
  ],
  resetBtn: {
    show: true,
    text: '重置'
  },
  otherComponents: [
    {
      render() {
        return (
          <BaseButton
            v-resource={[['新增模板']]}
            type="primary2"
            onClick={() => {
              useCreateModal(BiTmplAddDialog, {}, window.rootV3Instance);
            }}
          >
            新增模板
          </BaseButton>
        );
      }
    }
  ]
};
const tableConfig = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      fixed: 'left'
    }),
    useTableColumn({
      label: '模板编号',
      prop: 'templateCode',
      minWidth: 200
    }),
    useTableColumn({
      label: '模板名称',
      prop: 'templateName',
      minWidth: 200
    }),
    useTableColumn({
      label: '关联内容',
      prop: 'sceneType',
      width: '140px',
      formatter({ cellValue }) {
        return SCENE_MAPPING?.[cellValue]?.label || '-';
      }
    }),
    useTableColumn({
      label: '关联项目数量',
      prop: 'relateProjectCount',
      width: '120px',
      render: ({ row }) => {
        if (!row.relateProjectCount) return row.relateProjectCount;

        return (
          <BaseButton
            link
            type="primary2"
            disabled={!row.relateProjectCount}
            onClick={() => {
              useCreateModal(BiTmplProject, {
                id: row.id
              });
            }}
          >
            {row.relateProjectCount}
          </BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '操作人',
      prop: 'operator',
      width: '180px'
    }),
    useTableColumn({
      label: '创建时间',
      prop: 'createDt',
      width: '180px',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '更新时间',
      prop: 'updateDt',
      width: '180px',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '模板状态',
      prop: 'status',
      width: '120px',
      render: ({ row }) => {
        return (
          <>
            <BaseSwitch
              disabled={
                row.status === START_UP ||
                !resource.checkPermission('停用_启用')
              }
              activeValue={1}
              inactiveValue={2}
              model-value={row.status}
              beforeChange={async () => {
                await XrkMessageBox.confirm(
                  '新模板启用后，仅对未提交结算的项目生效，已提交结算的项目仍然使用旧模板，请确认后再启用新模板',
                  '提示',
                  {
                    confirmButtonText: '确认启用',
                    cancelButtonText: '暂不启用'
                  }
                );
                await enable({ templateId: row.id });
                xrkTableRef.value.initCurrentList();
                XrkMessage.success('操作成功！');
              }}
            ></BaseSwitch>
          </>
        );
      }
    }),

    useTableColumn({
      label: '操作',
      width: '220px',
      prop: 'handler',
      render({ row }) {
        // 停用并且没有关联项目才可编辑
        const editDisabled = row => {
          if (row.status === START_UP) return true;
          if (row.relateProjectCount) return true;
          if (row.id < 0) return true;
          return false;
        };
        return (
          <>
            <BaseButton
              v-resource={[['编辑']]}
              type="text"
              disabled={editDisabled(row)}
              onClick={() => {
                router.push({
                  name: 'bi-tmpl-detail',
                  query: {
                    id: row.id,
                    type: 'edit'
                  }
                });
              }}
            >
              编辑
            </BaseButton>
            <BaseButton
              type="text"
              onClick={() => {
                router.push({
                  name: 'bi-tmpl-detail',
                  query: {
                    id: row.id,
                    type: 'check'
                  }
                });
              }}
            >
              查看
            </BaseButton>
            <BaseButton
              type="text"
              onClick={async () => {
                const store = useBiTmplDetailSteup();
                const { onPreview } = usePreview();
                await store.initTmpl(row.id, null, null, 1);
                onPreview();
              }}
            >
              预览
            </BaseButton>
            <BaseButton
              v-resource={[['删除']]}
              type="text"
              disabled={editDisabled(row)}
              onClick={async () => {
                await XrkMessageBox.confirm('是否确认删除模板？', '提示', {
                  confirmButtonText: '确认删除',
                  cancelButtonText: '取消'
                });
                await deleteTel({
                  templateId: row.id,
                  enterpriseType: row.enterpriseType,
                  enterpriseId: row.enterpriseId
                });
                await xrkTableRef.value.initCurrentList();
                XrkMessage.success('操作成功！');
              }}
            >
              删除
            </BaseButton>
          </>
        );
      }
    })
  ].filter(Boolean)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig,
      tableConfig: tableConfig,
      requestNow: true,
      paginationConfig: {
        paginationPageSize: 15
      }
    }, null, 512)
  ]))
}
}

})